import { space } from './space';

export interface TokenType {
  space: {
    page: {
      xxs: string;
      xs: string;
      sm: string;
      md: string;
      lg: string;
      xl: string;
      xxl: string;
    };
  };
}

export const tokens: TokenType = {
  space: {
    page: {
      xxs: space(100),
      xs: space(200),
      sm: space(300),
      md: space(400),
      lg: space(500),
      xl: space(600),
      xxl: space(700),
    },
  },
};
